(function() {
  (() => {
    const WIDGET_SELECTOR = "#dg-chat-widget-launcher";
    const DEFAULT_BOTTOM = 16;
    const POLL_INTERVAL = 500;
    const MAX_POLL_TIME = 1e4;
    const TRANSITION = "bottom 150ms cubic-bezier(0.4, 0, 0.2, 1)";
    let widgetEl = null;
    let currentNudge = 0;
    function applyPosition(animate = true) {
      if (!widgetEl) return;
      widgetEl.style.transition = animate ? TRANSITION : "none";
      widgetEl.style.bottom = `${DEFAULT_BOTTOM + currentNudge}px`;
    }
    function handleNudge(event) {
      const transform = event.detail?.transform || "";
      const match = transform.match(/translateY\(-(\d+)px\)/);
      currentNudge = match ? Number(match[1]) : 0;
      applyPosition();
    }
    function getInitialNudge() {
      const stickyEl = document.querySelector("[data-sticky]");
      if (!stickyEl || stickyEl.classList.contains("translate-y-full")) return 0;
      const styles = window.getComputedStyle(stickyEl);
      const marginTop = parseInt(styles.marginTop, 10) || 0;
      const marginBottom = parseInt(styles.marginBottom, 10) || 0;
      return stickyEl.offsetHeight + marginTop + marginBottom;
    }
    function init(el) {
      widgetEl = el;
      currentNudge = getInitialNudge();
      applyPosition(false);
      document.addEventListener("global-ui:bottom-right-nudge", handleNudge);
    }
    const started = Date.now();
    const timer = setInterval(() => {
      const el = document.querySelector(WIDGET_SELECTOR);
      if (el) {
        clearInterval(timer);
        init(el);
        return;
      }
      if (Date.now() - started > MAX_POLL_TIME) clearInterval(timer);
    }, POLL_INTERVAL);
  })();
})();